import { render, staticRenderFns } from "./SPKLU.vue?vue&type=template&id=3cc8d99b"
import script from "./SPKLU.vue?vue&type=script&lang=js"
export * from "./SPKLU.vue?vue&type=script&lang=js"
import style0 from "./SPKLU.vue?vue&type=style&index=0&id=3cc8d99b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports